export default class Stand {
  private readonly _id: string;
  private readonly _hall: string;
  private readonly _name: string;


  private readonly standHallDelimiter = '&nbsp;'

  constructor(entity) {
    this._id = entity.ID;
    this._hall = entity.HALLE;
    this._name = entity.NAME;
  }


  get id(): string {
    return this._id;
  }

  get hall(): string {
    return this._hall;
  }

  get name(): string {
    return this._name;
  }

  public getDisplayName(): string {
    return `${this._hall}${this.standHallDelimiter}${this._name}`;
  }

}
